import { Platform, StyleSheet } from "react-native";
const style = StyleSheet.create({
    header: {
        flexDirection: "row",
        width: "100%",
        zIndex: 3,
    },
    stickyHeader: {
        ...Platform.select({
            web: {
                position: "sticky",
                top: 0,
                zIndex: 10,
            },
            native: {
                position: "relative",
            },
        }),
    },
});
export { style };
